export default __webpack_public_path__ + "static/media/kn.09e60f17.svg";